import React from 'react'
import { COLORS } from '../../theme'
import Text from './TextNew'

interface Props {
  notificationsCount?: number
  onClick?: () => void
  withPlus?: boolean
  iconComponent: JSX.Element
  color?: keyof typeof COLORS
  backgroundColor?: keyof typeof COLORS
  borderColor?: keyof typeof COLORS
  style?: React.CSSProperties
  circleSize?: number
  circleRight?: number
  circleTop?: number
  dataTestId?: string
}

const formatNotificationsCount = (count: number): string => {
  if (count > 9) {
    return '+9'
  }
  return `${count}`
}

const Icon = ({
  onClick,
  color = 'errorRed',
  iconComponent,
  style,
  notificationsCount = 1,
  backgroundColor = 'groupBlue',
  borderColor = 'groupBlue',
  circleSize = 4,
  circleRight = -2,
  circleTop = 0,
  dataTestId
}: Props): JSX.Element => {
  const circleStyles = 'absolute flex justify-center items-center rounded-4'
  const borderStyles = `1px solid ${COLORS[borderColor]}`
  return (
    <div className="relative" onClick={onClick} style={style} data-testid={dataTestId}>
      {notificationsCount > 0 && (
        <div
          className={`${circleStyles}`}
          style={{
            border: borderStyles,
            backgroundColor: COLORS[backgroundColor],
            height: circleSize * 4,
            width: circleSize * 4,
            right: circleRight,
            top: circleTop
          }}>
          <Text className="text-m font-Bold" style={{ color: COLORS[color] }}>
            {formatNotificationsCount(notificationsCount)}
          </Text>
        </div>
      )}
      {iconComponent}
    </div>
  )
}

export default Icon
